<template>
    <div class="main">
        <Header></Header>
        <router-view />
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
// import { resize } from "@/common/flexible";
export default {
    name: "Main",
    data() {
        return {};
    },
    components: {
        Header,
        Footer,
    },
    computed: {},
    methods: {},
    mounted() {
        // resize();
    },
};
</script>
<style scoped>
.main {
    position: relative;
}
.header {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: 10;
}
</style>